import { useNode } from "@craftjs/core";
import * as React from "react";
import type { Sponsor, SponsorLayout } from "src/types";

import TopLevelFloatingOptions from "@/components/editor/block-outline/floating-options/top-level-floating-component";
import Text from "@/components/editor/primitives/text/text-component";
import {
  BlockBackgroundColorWrapper,
  BlockMaxWidthWrapper,
  BlockPaddingWrapper,
} from "@/components/editor/shared/block-wrapper";
import SponsorsSettings from "@/components/editor/shared/sponsors/sponsors-settings/sponsors-settings-component";
import Element from "@/components/element/element-component";

import SponsorCard from "./sponsor-card/sponsor-card-component";
import SponsorsList from "./sponsors-list-component";

type SponsorsProps = {
  sponsors?: Sponsor[];
  title: string;
  layout: SponsorLayout;
};

export default function Sponsors({ sponsors, title, layout }: SponsorsProps) {
  const {
    connectors: { connect },
    nodeId,
  } = useNode((node) => ({
    nodeId: node.id,
  }));

  return (
    <BlockBackgroundColorWrapper ref={connect} id={nodeId}>
      <BlockPaddingWrapper>
        <BlockMaxWidthWrapper>
          <div className="flex justify-center">
            <Element
              id="sponsor-title"
              is={Text}
              element="h2"
              text={title}
              pattern="headingTwo"
            />
          </div>
          <Element id="sponsors-list" is={SponsorsList} layout={layout} canvas>
            {sponsors?.map((sponsor) => (
              <SponsorCard key={sponsor.id + sponsor.name} sponsor={sponsor} />
            ))}
          </Element>
        </BlockMaxWidthWrapper>
      </BlockPaddingWrapper>
    </BlockBackgroundColorWrapper>
  );
}

Sponsors.craft = {
  custom: {
    displayName: "Sponsors",
  },
  related: {
    leftOutlineOptions: TopLevelFloatingOptions,
    settings: SponsorsSettings,
  },
};
